import { Image } from 'hatch-components';
import styled from 'styled-components';
import generateBackgroundColor from 'utils/generateColor';

export const StyledUserAvatar = styled.section(
  ({ icon, theme, colorId, type }) => {
    const {
      colors: { iconBackgrounds: colorsArr, text, white, lavender },
      font,
    } = theme;
    const { isDark, color } = generateBackgroundColor(colorId, colorsArr);
    const bgColor = type === 'contact' ? white : color;
    const borderColor = type === 'contact' ? lavender : color;
    let textColor = text.primary;

    if (type === 'contact') {
      textColor = lavender;
    } else if (isDark) {
      textColor = text.tertiary;
    }

    return {
      alignItems: 'center',
      background: icon ? 'transparent' : bgColor,
      border: `1px solid ${icon ? 'transparent' : borderColor}`,
      borderRadius: '100%',
      color: textColor,
      display: 'flex',
      flexShrink: 0,
      fontSize: font.size.sm,
      fontWeight: font.weight.bold,
      height: '36px',
      img: {
        height: '100%',
        objectFit: 'cover',
        width: '100%',
      },
      justifyContent: 'center',
      lineHeight: font.size.sm,
      position: 'relative',
      textTransform: 'uppercase',
      userSelect: 'none',
      width: '36px',
    };
  },
);

export const StyledImage = styled(Image)(() => ({
  borderRadius: '100%',
  height: '100%',
  width: '100%',
}));

export const StyledSkeletonLoader = styled.aside({
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  width: '100%',
});
